export default __webpack_public_path__ + "static/media/icon-messages-blue.9edbda09.svg";